module.exports = __webpack_public_path__ + "static/media/Smit22.3c7e3970.png";